// Libraries
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

// Services
import { AuthService } from 'src/app/services/core/auth.service';

// Role in order hierarchy: guest < user < userAdmin < admin < dev
const ROLE_HIERARCHY = ['guest', 'user', 'userAdmin', 'admin', 'dev'];

function hasMinimumRole(userRole: string, minimumRole: string): boolean {
    const userIdx = ROLE_HIERARCHY.indexOf(userRole);
    const minIdx = ROLE_HIERARCHY.indexOf(minimumRole);
    return userIdx >= minIdx;
}

@Injectable({ providedIn: 'root' })

export class RoleGuard implements CanActivate {
    // Services
    private readonly auth: AuthService = inject(AuthService);
    private readonly router: Router = inject(Router);

    constructor() { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const minimumRole = route.data['minimumRole'] as string;
        const user = this.auth.currentUser();

        if (!user) {
            this.auth.requireLogin(state.url);
            return false;
        }

        if (!user.role?.name || !hasMinimumRole(user.role.name, minimumRole)) {
            this.router.navigate(['/forbidden']);
            return false;
        }

        return true;
    }
}